export default (str = ''): string[] =>
  str.match(/(>)(.*?)(?=\<)/g)?.map(el => el?.replace('>', '')) || [str];
